import $ from "jquery";

class CollapsibleContent {

    constructor($element) {
        this.$element = $element;
        this.isOpen = false;

        this.attachEvents();
    }

    attachEvents() {
        const button = this.$element.find('.component-collapsible-content__button > button').first();
        const closeButton = this.$element.find('.component-collapsible-content__close-button > button').first();

        button.click(() => {
            this.toggle();
        });

        closeButton.click(() => {
            this.close();
        });
    }

    toggle() {
        if(this.isOpen) {
            this.close();

            return;
        }

        this.open();
    }

    open() {
        if(this.isOpen) {
            return;
        }

        this.$element.addClass('component-collapsible-content--open');
        //this.$element.find('.component-collapsible-content__content__inner').slideDown();
        this.isOpen = true;
    }

    close() {
        if(this.isOpen === false) {
            return;
        }
        //this.$element.find('.component-collapsible-content__content__inner').slideUp();
        this.isOpen = false;

        const navigationHeight = $('body > header').outerHeight();

        $('html, body')
            .animate({ scrollTop: this.$element.offset().top - navigationHeight }, {
                duration: 500,
                always: () => {
                    this.$element.removeClass('component-collapsible-content--open');
                }
            });
    }

}

export default function() {
    $(".component-collapsible-content").each(function() {
        const collapsibleContent = new CollapsibleContent($(this));
    })
}

